import { FETCH_PORTAL_FILTERS, UPDATE_FILTERS } from "../constants";
const initialState = {
  productoBusqueda:[],
  tags:[],
  categorias:[],
  subcategorias:[],
};
const portalReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PORTAL_FILTERS:
      return state;
    case UPDATE_FILTERS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default portalReducer;